import React from "react";
import Footer from "../../components/Footer";
import PharmacyImg from "../../assets/images/diplomao.jpeg";
import { Link } from "react-router-dom";
import { ChevronRight, BookOpen, Briefcase, Target } from "lucide-react";
import Title from "../../components/TitleComponent";
const DiplomaFrontOffice = () => {
  const sections = [
    {
      title: "Eligibility Criteria",
      content: "10+2 (In any Stream)",
      icon: <BookOpen className="text-[#23376c]" size={30} />,
    },
    {
      title: "Career Prospects of the Course",
      list: ["Hotels", "Hospital", "Airline", "Cruise Industry", "Customer Relations"],
      icon: <Target className="text-[#23376c]" size={30} />,
    },
    {
      title: "Career Options",
      list: [
        "Front Desk Agent",
        "Guest Service Representative",
        "Front Office Supervisor",
        "Hotel Operations Manager",
        "Resort Manager",
        "Ground Operator",
        "Airport Representative",
        "Customer Relation Manager",
      ],
      icon: <Briefcase className="text-[#23376c]" size={30} />,
    },
  ];

  return (
    <div className="w-full relative font-poppins bg-gray-50">
      <Title canonicalPath="/programmes/diploma-courses/diploma-in-front-office" />
      <Title title="Diploma in Front Office Management at Maya Devi University" description="Enroll in the Diploma in Front Office Management at MDU, Dehradun. Develop key skills for a successful career in hospitality and customer service." />
      <div className="w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5">
        <div className="text-center">
          <h2 className="mb-4 text-2xl md:text-6xl tracking-tight font-bold text-[#0e4d38] relative">
            Diploma in Front Office
            <div className="w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] absolute left-1/2 transform -translate-x-1/2 bottom-[-15px]"></div>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between items-center">
          <img
            src={PharmacyImg}
            alt="Diploma in Front Office"
            className="md:w-[40%] rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
          />
          <div className="flex flex-col gap-4 md:w-1/2">
            <h4 className="font-bold text-xl md:text-3xl text-[#23376c]">About the Department</h4>
            <p className="text-justify md:text-lg text-gray-700">
              The Diploma in Front Office is an extensive 1 ½ year program aimed at equipping
              students for fulfilling careers in the hospitality sectors. This program provides
              comprehensive knowledge and practical skills vital for excelling in the hospitality
              industry’s front office operations. It equips individuals with expertise in managing
              front desk operations, delivering exceptional guest services, and honing leadership
              abilities essential for navigating the dynamic hospitality landscape.
            </p>
            <Link to="https://admission.maya.edu.in/" className="self-start">
              <button className="mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2 group">
                Register Now
                <ChevronRight className="group-hover:translate-x-1 transition-transform" size={20} />
              </button>
            </Link>
          </div>
        </div>

        {/* Programme Details Table */}
        <div className="bg-white shadow-md rounded-lg overflow-x-auto mb-10">
          <table className="min-w-full text-center text-sm font-light">
            <thead className="bg-[#23376c] text-white">
              <tr>
                {[
                  "Programme",
                  "Branch/ Specialization",
                  "Duration (Years)",
                  "No. of Seats",
                  // "One-time Charges (Including Registration)",
                  // "Yearly Fee (All India Quota)",
                  // "Yearly Fee (UK Domicile)",
                ].map((header, index) => (
                  <th key={index} className="px-6 py-4 font-semibold">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="whitespace-nowrap px-6 py-4 font-semibold">Diploma</td>
                <td className="whitespace-nowrap px-6 py-4">Front Office</td>
                <td className="whitespace-nowrap px-6 py-4">1</td>
                <td className="whitespace-nowrap px-6 py-4">20</td>
                {/* <td className="whitespace-nowrap px-6 py-4">Rs. 11,000/-</td>
                <td className="whitespace-nowrap px-6 py-4">Rs. 60,000/-</td>
                <td className="whitespace-nowrap px-6 py-4">Rs. 45,000/-</td> */}
              </tr>
            </tbody>
          </table>
        </div>

        {/* Cards Section */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-10">
          {sections.map((section, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-6 bg-white shadow-lg rounded-lg transition-transform hover:scale-105"
            >
              <div className="mb-4">{section.icon}</div>
              <h4 className="text-xl font-semibold text-[#23376c] mb-2">{section.title}</h4>
              {section.list ? (
                <ul className="text-gray-700 list-disc text-left pl-4">
                  {section.list.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className="text-gray-700">{section.content}</p>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DiplomaFrontOffice;
